<template>
	<div>
		<div class="d-flex justify-content-between align-items-center mb16">
			<div class="fsp20 lh28 neue">
				{{ $t('views.Merchant.ChoiseShop.1') }}
			</div>
			<Icon name="close" class="c24 pointer" @click="close()" />
		</div>
		<div class="neue-roman" :class="{ 'p24 bg-white rounded12': !isMobile }">
			<div class="input-search-wrapper" :class="{ 'mb16': isMobile, 'mb24': !isMobile }">
				<span class="d-flex justify-content-center align-items-center">
					<Icon name="search-grey" class="c16 mr8" :active="false" />
				</span>
				<input
					class="input-search flex-grow-1 pr4"
					ref="input_search"
					type="text"
					@input="inputSearchHandler"
					tabindex="-1"
					:placeholder="$t('components.service.TableList.1')"
				/>
				<span @click.stop="clearSearchInput" class="pointer">
					<Icon v-if="textInSearch" name="clear-search" class="pe-none c16 d-flex justify-content-center align-items-center" />
				</span>
			</div>
			<div class="shop-container" :class="{ 'shop-container--mobile': isMobile }">
				<div class="shop-wrapper" :class="{ 'shop-wrapper--mobile': isMobile }">
					<div v-if="filteredShops.length > 0" class="d-flex flex-wrap gap16">
						<div
							v-for="shop in filteredShops"
							class="d-flex align-items-center p16 shop-item gap8"
							:class="{ 'shop-item--mobile': isMobile, 'shop-item-selected': isShopSelected(shop) }"
							:key="shop.code || shop.num"
							@click="choiseShop(shop)"
						>
							<span v-if="shop.logo" class="shop-logo-wrapper">
								<img :src="shop.logo" :alt="shop.name || 'store'" class="shop-logo" />
							</span>
							<span v-else class="shop-logo-wrapper shop-logo-placeholder">
								<Icon name="shop-placeholder" class="c24" />
							</span>
							<span class="fsp14 lh20 neue">{{ shop.name || $t('views.Merchant.ChoiseShop.2') }}</span>
							<div
								v-if="isShopSelected(shop)"
								@click.stop="clearSelection"
							>
								<Icon name="close" :color="{ 0: '#122157' }" class="c16" />
							</div>
						</div>
					</div>
					<div v-else class="d-flex col-12">
						<span class="primary-grey">{{ $t('views.P2P.CheckCurrP2POffers.9') }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Icon from '@/components/icons/Icon';

export default {
	components: {
		Icon
	},
	props: {
		close: [Function]
	},
	data() {
		const content = this.$store.state.modal.content;
		return {
			content,
			shops: content.shops || [],
			selectedShopCode: content.selectedShop || null,
			filteredShops: [],
			textInSearch: false
		};
	},
	computed: {
		isMobile() {
			return this.$store.state.resize.w <= 768;
		}
	},
	methods: {
		inputSearchHandler(event) {
			const searchValue = event.target.value.toLowerCase();
			this.textInSearch = searchValue ? true : false;

			if (!searchValue) {
				this.filteredShops = [...this.shops];
				return;
			}

			this.filteredShops = this.shops.filter(shop => {
				const name = (shop.name || '').toLowerCase();
				const code = String(shop.code || shop.num || '').toLowerCase();
				return name.includes(searchValue) || code.includes(searchValue);
			});
		},
		isShopSelected(shop) {
			const shopCode = shop.num || shop.code;
			return this.selectedShopCode === shopCode;
		},
		choiseShop(shop) {
			if (this.content.onSelect) {
				this.content.onSelect(shop);
			}
		},
		clearSelection() {
			this.selectedShopCode = null;
			if (this.content.onClear) {
				this.content.onClear();
			}
		},
		clearSearchInput() {
			if (this.$refs.input_search) {
				this.$refs.input_search.value = '';
			}
			this.textInSearch = false;
			this.filteredShops = [...this.shops];
		}
	},
	mounted() {
		this.filteredShops = [...this.shops];
	}
};
</script>

<style lang="scss" scoped>
.input-search-wrapper {
	display: flex;
	width: 100%;
	background-color: white;
	border: 1px solid $primary-stroke;
	border-radius: 8px;
	position: sticky;
	top: 0;
	left: 0;
	padding: 10px 16px 10px 12px;
	height: 40px;
}

.input-search {
	width: calc(100% - 20px);
	border: none;

	&::placeholder {
		color: $primary-grey !important;
	}
}

.input-search:focus,
.input-search:focus-visible {
	border: none;
	outline: none;
}

.shop-container {
	max-height: 60vh;

	&--mobile {
		max-height: none;
	}
}

.shop-wrapper {
	max-height: 45vh;
	overflow-y: auto;
	overflow-x: hidden;
	padding-right: 8px;

	&::-webkit-scrollbar {
		width: 4px;
		border-radius: 2px;
	}

	&::-webkit-scrollbar-track {
		background: $menu-bg;
		background: color-mix(in srgb, #{$menu-bg} 20%, transparent);
		border-radius: 2px;
	}

	&::-webkit-scrollbar-thumb {
		background-color: $menu-bg;
		border-radius: 2px;
	}

	&--mobile {
		max-height: none;
	}
}

.shop-item {
	border-radius: 12px;
	cursor: pointer;
	width: calc(50% - 8px);
	border: 1px solid $primary-stroke;
	box-shadow: 0 4px 25px rgba(0, 0, 0, 0.05);

	&:hover {
		box-shadow: 0 6px 20px rgba($primary-stroke, 0.4);
	}

	&--mobile {
		width: 100%;
	}
}

.shop-logo-wrapper {
	width: 48px;
	height: 48px;
	flex-shrink: 0;
	border: 1px solid $primary-stroke;
	border-radius: 8px;
	overflow: hidden;
}

.shop-logo {
	width: 48px;
	height: 48px;
	border-radius: 8px;
	object-fit: cover;
}

.shop-logo-placeholder {
	background-color: $color-background;
	display: flex;
	align-items: center;
	justify-content: center;
}

.shop-item-selected {
	background-color: $bg-light-blue;
	border: 1px solid $menu-bg;
}
</style>
